// Axios
import axios from "axios";

// Helpers
import Helpers from '.';

// Config
import Config from '../config';

// Mobx
import SettingStore from "../mobx/stores/SettingStore";
import LanguageStore from "../mobx/stores/LanguageStore";
import TrainingStore from '../mobx/stores/TrainingStore';
import ProductCategoryStore from '../mobx/stores/ProductCategoryStore';
import StoreStore from '../mobx/stores/StoreStore';
import PageStore from '../mobx/stores/PageStore';
import CurrencyStore from '../mobx/stores/CurrencyStore';
import AccountNumberStore from '../mobx/stores/AccountNumberStore';
import PaymentTypeStore from '../mobx/stores/PaymentTypeStore';

const setSettings = async () => {
    // Language
    let locales = await axios.get(`${Config.App.apiUrl}/i18n/locales`);

    const contents = {};

    const languages = locales.data.map((locale: any) => {
        contents[locale.code] = [];
        return locale.code
    });

    const defaultLanguage = locales.data.filter((locale: any) => {
        return locale.isDefault
    })[0].code;
    let currentLanguage: any = localStorage.getItem('language');
    currentLanguage = currentLanguage !== null ? currentLanguage : defaultLanguage;

    let languageContents: any = await axios.get(`${Config.App.apiUrl}/${Config.ApiBackPoints.languages}?populate=*&pagination[page]=1&pagination[pageSize]=100000`);

    languageContents.data.data.map((content: any) => {
        contents[defaultLanguage].push({
            id: content.id,
            ...content.attributes
        })

        const localizations = content.attributes.localizations.data.map((localization: any) => {
            return {
                id: localization.id,
                ...localization.attributes
            }
        });

        languages
            .filter((language: any) => {
                return language !== defaultLanguage;
            })
            .map((language: any) => {
                const contentIndex = Helpers.findIndexByCriteria(localizations, "locale", language);
                if (contentIndex !== -1) {
                    contents[language].push(localizations[contentIndex]);
                }
            })
    });

    LanguageStore.updateLanguageData({
        contents,
        languages,
        currentLanguage,
        defaultLanguage,
    })
    // Language

    // Settings
    let settings: any = await axios.get(`${Config.App.apiUrl}/${Config.ApiBackPoints.settings}?populate=*`);
    settings = settings.data.data;
    settings = {
        id: settings.id,
        ...settings.attributes
    };

    SettingStore.updateSettings({
        ...SettingStore.settings,
        socketAddress: settings.socket_address,
        apiEndPoints: settings.api_endpoints,
        banner: settings.banner,
        description: settings.description,
        sertificate_types: settings.sertificate_types,
        payment_url: settings.payment_url
    });
    // Settings

    // First Data
    let stores: any = await axios.get(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.store}?pagination[page]=1&pagination[pageSize]=100000`);
    stores = stores.data.data;
    const storeDatas = {};
    await Promise.all(stores.map(async (store: any) => {
        storeDatas[store.id] = {
            id: store.id,
            ...store.attributes
        };
    }));
    StoreStore.setStores(storeDatas);

    let trainings: any = await axios.get(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.training}?populate=*&pagination[page]=1&pagination[pageSize]=100000`);
    trainings = trainings.data.data;
    const trainingDatas = {};
    await Promise.all(trainings.map(async (training: any) => {
        trainingDatas[training.id] = {
            id: training.id,
            ...training.attributes
        };
    }));
    TrainingStore.setTrainings(trainingDatas);

    let productCategories: any = await axios.get(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.productCategory}?populate[0]=image&populate[1]=main_categories&populate[2]=child_categories&pagination[page]=1&pagination[pageSize]=100000`);
    productCategories = productCategories.data.data;
    const productCategoryDatas = {};
    await Promise.all(productCategories.map(async (productCategory: any) => {
        productCategoryDatas[productCategory.id] = {
            id: productCategory.id,
            ...productCategory.attributes,
            content: {},
            page: 1,
            pageCount: 1
        };
    }));
    ProductCategoryStore.setProductCategories(productCategoryDatas);

    let pages: any = await axios.get(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.page}?pagination[page]=1&pagination[pageSize]=100000`);
    pages = pages.data.data;
    const pageDatas = {};
    await Promise.all(pages.map(async (page: any) => {
        pageDatas[page.id] = {
            id: page.id,
            ...page.attributes
        };
    }));
    PageStore.setPages(pageDatas);

    let currencies: any = await axios.get(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.currency}?populate[0]=current_transaction&pagination[page]=1&pagination[pageSize]=100000`);
    currencies = currencies.data.data;
    const currencyDatas = {};
    await Promise.all(currencies.map(async (currency: any) => {
        currencyDatas[currency.id] = {
            id: currency.id,
            ...currency.attributes
        };
    }));
    CurrencyStore.setCurrencies(currencyDatas);

    let accountNumbers: any = await axios.get(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.accountNumber}?populate[0]=logo&pagination[page]=1&pagination[pageSize]=100000`);
    accountNumbers = accountNumbers.data.data;
    const accountNumberDatas = {};
    await Promise.all(accountNumbers.map(async (accountNumber: any) => {
        accountNumberDatas[accountNumber.id] = {
            id: accountNumber.id,
            ...accountNumber.attributes
        };
    }));
    AccountNumberStore.setAccountNumbers(accountNumberDatas);

    let paymentTypes: any = await axios.get(`${Config.App.apiUrl}/${Helpers.getSettings().apiEndPoints.paymentType}?pagination[page]=1&pagination[pageSize]=100000`);
    paymentTypes = paymentTypes.data.data;
    const paymentTypeDatas = {};
    await Promise.all(paymentTypes.map(async (paymentType: any) => {
        paymentTypeDatas[paymentType.id] = {
            id: paymentType.id,
            ...paymentType.attributes
        };
    }));
    PaymentTypeStore.setPaymentTypes(paymentTypeDatas);
    // First Data
}

const getSettings = () => {
    return SettingStore.settings;
}

const exportHelpers = {
    setSettings,
    getSettings
}

export default exportHelpers;